
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";

const Auth = namespace("Auth");

@Component({
  name: "FiltroOrdenacaoProdutos",
})
export default class FiltroOrdenacaoProdutos extends Vue {
  @Auth.Getter
  private isLoggedIn!: boolean;

  ordenacao_selected: any = null;

  listaOrdenacao: any[] = [
    {
      id: "AZ",
      label: "A-Z",
    },
    {
      id: "ZA",
      label: "Z-A",
    },
  ];

  mounted() {
    if (this.isLoggedIn) {
      this.listaOrdenacao.push(
        {
          id: "MENOR_PRECO",
          label: "Menor Preço",
        },
        {
          id: "MAIOR_PRECO",
          label: "Maior Preço",
        }
      );
    }

    this.ordenacao_selected = this.$route.query.sortId;
  }

  onOrdenacaoChange(value: any) {
    this.$router.push({ query: { ...this.$route.query, sortId: value } });
  }

  // @Watch("ordenacao_selected")
  ordenacao(value: any) {
    // if (this.$route.query.sortId == value) return;

    const url = new URL(window.location.href);

    if (value) {
      url.searchParams.set("sortId", value);
      window.history.pushState({}, "", url.toString());

      this.$emit("input", value);
      return;
    }

    url.searchParams.delete("sortId");
    window.history.pushState({}, "", url.toString());

    this.$emit("input", null);
  }
}
